import React from 'react';

// Shared loading / empty / error states for the sales views.

export const Bone = ({ className = '' }) => <div className={`sales-bone ${className}`} aria-hidden="true" />;

// Thin indeterminate bar shown while refetching with previous data still on screen.
export const RefetchBar = () => (
  <div className="sales-refetch-bar" role="progressbar" aria-label="Updating" data-testid="sales-refetch-bar" />
);

const ChartGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 3v18h18" />
    <path d="M7 15l4-4 3 3 5-6" />
  </svg>
);

const AlertGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 9v4M12 17h.01" />
    <path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z" />
  </svg>
);

export const ErrorState = ({ message, onRetry, testId }) => (
  <div className="sales-card sales-enter flex flex-col items-center text-center py-12 gap-4" role="alert" data-testid={testId}>
    <span className="sales-state-icon border-battle-red/40 bg-battle-red-glow text-battle-red-light"><AlertGlyph /></span>
    <div>
      <p className="text-gray-100 font-medium">{message}</p>
      <p className="text-gray-500 text-sm mt-1">Check the connection and try again.</p>
    </div>
    <button type="button" onClick={onRetry} className="sales-btn sales-btn-primary">Retry</button>
  </div>
);

export const InlineError = ({ onRetry }) => (
  <div className="sales-enter flex flex-wrap items-center justify-between gap-3 px-4 py-2.5 rounded-xl border border-battle-red/35 bg-battle-red-glow text-sm text-gray-200" role="alert">
    <span className="flex items-center gap-2 min-w-0">
      <span className="w-1.5 h-1.5 rounded-full bg-battle-red-light shrink-0" aria-hidden="true" />
      Could not refresh. Showing the last loaded figures.
    </span>
    <button type="button" onClick={onRetry} className="sales-btn">Retry</button>
  </div>
);

export const EmptyState = ({ title, children, testId }) => (
  <div className="sales-card sales-enter flex flex-col items-center text-center py-12 gap-4" data-testid={testId}>
    <span className="sales-state-icon border-army/40 bg-army/15 text-army-light"><ChartGlyph /></span>
    <div>
      <p className="sales-title text-lg sm:text-lg">{title}</p>
      {children && <p className="text-gray-400 text-sm mt-2 max-w-md mx-auto">{children}</p>}
    </div>
  </div>
);
